// extracted by mini-css-extract-plugin
module.exports = {"form":"request-form_form__eKSvG","formText":"request-form_formText__7Sj9l","success":"request-form_success__TwzSf","hiddenLabels":"request-form_hiddenLabels__MkYFZ"};